import GUI from "lil-gui";

export default class Debug {
  active: boolean;
  ui?: GUI;

  constructor() {
    const debugFromHash = window.location.hash === "#debug";
    const debugFromEnv = String(import.meta.env.VITE_DEBUG || "").toLowerCase() === "true";
    this.active = debugFromHash || debugFromEnv;
    if (this.active) {
      this.ui = new GUI();
    }
  }
}
